import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Checkbox, Collapse, Fade, FormControl, FormErrorMessage, FormHelperText, FormLabel, Heading, HStack, Icon, Input, List, ListItem, OrderedList, ScaleFade, Stack, Text, useDisclosure, VStack, Link, Image, Select, calc, Modal } from "@chakra-ui/react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import GreyBox from '../style/components/greyBox';
import { FaAngleDown, FaAsterisk } from "react-icons/fa";
import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import AlertErrors from "../style/components/alertErrors";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import he from "date-fns/locale/he";
import "../style/css/datepicker.css";
import moment from "moment";
import api from "../services/api";
import FullScreenLoader from "../style/components/fullScreenLoader";

export default function ClientCreationForm({ initialData }) {

  const { register, handleSubmit, reset, formState: { errors, isValid, isDirty, touchedFields }, control, setValue, trigger, watch } = useForm({
    mode: 'onChange',
    defaultValues: {
      excludedProducts: [{ accountNumber: "", code: "" }]
    }
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "excludedProducts",
  });

  const lastNameValue = watch('lastName');
  const firstNameValue = watch('firstName');
  const idNumberValue = watch('idNumber');
  const phoneNumberValue = watch('phoneNumber');
  const emailValue = watch('email');
  const jobDescriptionValue = watch('jobDescription');
  const compensationBudgetValue = watch('compensationBudget');
  const continuingEducationFundSalaryValue = watch('continuingEducationFundSalary');
  const empNameValue = watch('empName');
  const empNumberValue = watch('empNumber');
  const empEmailValue = watch('empEmail');
  const empPhoneNumberValue = watch('empPhoneNumber');

  const formOwnerNameValue = watch('formOwnerName');
  const employeeCompensationBudgetValue = watch('employeeCompensationBudget');
  const employerBenefitsBudgetValue = watch('employerBenefitsBudget');
  const employeeAndEmployerSocialSecurityContributionsValue = watch('employeeAndEmployerSocialSecurityContributions');
  const budgetOfAkaValue = watch('budgetOfAka');

  
  

  const startEmpDateValue = watch('startEmpDate');
  const insuredSalaryValue = watch('insuredSalary');
  const [isloading, setIsLoading] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);


  const fieldLabels = {
    formOwnerName: 'שם ממלא הטופס',
    lastName: 'שם משפחה',
    firstName: 'שם פרטי',
    idNumber: 'תעודת זהות',
    empName: 'שם מעסיק',
    empNumber: 'ח.פ מעסיק',
    street: 'רחוב',
    houseNumber: 'מספר בית',
    phoneNumber: 'טלפון נייד',
    email: 'דואר אלקטרוני',
    additionalPhoneNumber: 'טלפון נוסף',
    startEmpDate: 'תאריך תחילת עבודה ',
    issueDate: 'תאריך הנפקת תעודת זהות',
    additionalEmail: 'דואר אלקטרוני בן/בת זוג',
    signatureAccText: 'טקסט חתימה',
    empEmail: 'אמייל מעסיק',
    empPhoneNumber: 'נייד מעסיק'

  };

  const [isAccessibleSignature, setIsAccessibleSignature] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [invalidFields, setInvalidFields] = useState([]);
  const [showFirst, setShowFirst] = useState(false);
  const [showSecond, setShowSecond] = useState(false);
  const [showThird, setShowThird] = useState(false);

  const getFieldStyles = (touched, error, value) => {
    const stringValue = typeof value === "string" ? value.trim() : value;
    const isValid = touched && !error && stringValue !== '' && stringValue !== undefined;
    return {
      color: isValid ? '#468847' : '',
      backgroundColor: isValid ? '#DFF0D8' : '',
      border: isValid ? '1px solid #D6E9C6' : '',
    };
  };

  const addHarigField = () => {
    append({ accountNumber: "", code: "" });
  };

  const removeHarigField = (index) => {
    remove(index);
  };

  const handleFormSubmit = async (formData) => {
    setIsLoading(true);
    const dataForServer = { ...formData }
    dataForServer.price = initialData.price;
    const resp = await api.epSendClientData(dataForServer);
    try {
      if (resp.status === 200) {
        if(initialData.price > 0)
          window.location.href = initialData.invoiceUrl;
        else
        {
          setIsLoading(false);
          alert("הטופס נשלח בהצלחה");
          window.location.reload(); // Reload the page
          
        }
        //setIsFormSubmitted(true); //not needed because we will go to another url
        // alert("הטופס נשלח בהצלחה");
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      
    }
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    const isValid = await trigger();
    if (isValid) {
      handleSubmit(handleFormSubmit)();
    } else {
      const errorFields = Object.keys(errors);
      const errorLabels = errorFields.map(field => fieldLabels[field]);
      setInvalidFields(errorLabels);
      onOpen();
    }
  };
  useEffect(() => {
    reset();
  }, [isFormSubmitted]);

  return (
    <Box
      as="form"
      mt="20px"
      px="15px"
      onSubmit={handleSubmitClick} // שים לב שהולכים לפי הפונקציה של onSubmit
    >

<Stack as="fieldset">
        <Stack as="legend" w="100%" borderBottom={"1px solid #e5e5e5"} mb="20px">
          <Heading as="h2" variant={"h2"}>פרטי מעסיק</Heading>
        </Stack>
        <GreyBox>
        <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
        <FormControl isInvalid={!!errors.empName} flex="1">
              <FormLabel>שם מעסיק
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.empName, errors.empName, empNameValue)}
                autoComplete="off"
                {...register("empName", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[\u0590-\u05FF\s]+$/, // Regular expression for Hebrew characters
                    message: "נא להזין שם מעסיק בעברית בלבד",
                  },
                })}
              />
              {errors.empName && (
                <FormErrorMessage color="primary.error">
                  {errors.empName.message}
                </FormErrorMessage>
              )}
            </FormControl>

            <FormControl isInvalid={!!errors.empNumber} flex="1">
              <FormLabel>ח.פ מעסיק
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה "
                style={getFieldStyles(touchedFields.empNumber, errors.empNumber, empNumberValue)}
                autoComplete="off"
                {...register("empNumber", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "יש להזין ספרות בלבד",
                  },
                })}
              />
              {errors.empNumber && (
                <FormErrorMessage color="primary.error">
                  {errors.empNumber.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.formOwnerName} flex="1">
              <FormLabel>שם ממלא הטופס
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.formOwnerName, errors.formOwnerName, formOwnerNameValue)}
                autoComplete="off"
                {...register("formOwnerName", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[\u0590-\u05FF\s]+$/, // Regular expression for Hebrew characters
                    message: "נא להזין שם  בעברית בלבד",
                  },
                })}
              />
              {errors.formOwnerName && (
                <FormErrorMessage color="primary.error">
                  {errors.formOwnerName.message}
                </FormErrorMessage>
              )}
            </FormControl>
            

        </Stack>
        <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
        <FormControl isInvalid={!!errors.empEmail} flex="1">
              <FormLabel>מייל מעסיק
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="דוגמא: mail@example.com"
                style={getFieldStyles(touchedFields.empEmail, errors.empEmail, empEmailValue)}
                autoComplete="off"
                {...register("empEmail", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "דואר אלקטרוני לא תקני",
                  },
                })}
              />
              {errors.empEmail && (
                <FormErrorMessage color="primary.error">
                  {errors.empEmail.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.empPhoneNumber} flex="1">
              <FormLabel>טלפון מעסיק
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="דוגמא 055-5555555"
                style={getFieldStyles(touchedFields.empPhoneNumber, errors.empPhoneNumber, empPhoneNumberValue)}
                autoComplete="off"
                maxLength={11}
                {...register("empPhoneNumber", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^(0[23489]\d{7}|0[23489]-?\d{7}|05[0-9]\d{7}|05[0-9]-?\d{7})$/,
                    message: "מספר טלפון לא תקני",
                  },
                })}
              />
              {errors.empPhoneNumber && (
                <FormErrorMessage color="primary.error">
                  {errors.empPhoneNumber.message}
                </FormErrorMessage>
              )}
            </FormControl>
            
            

        </Stack>
        
        </GreyBox>
</Stack>
      
      <Stack as="fieldset">
        <Stack as="legend" w="100%" borderBottom={"1px solid #e5e5e5"} mb="20px">
          <Heading as="h2" variant={"h2"}>פרטי העובד</Heading>
        </Stack>
        <GreyBox>
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
            <FormControl isInvalid={!!errors.lastName} flex="1">
              <FormLabel>שם משפחה
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.lastName, errors.lastName, lastNameValue)}
                autoComplete="off"
                {...register("lastName", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[\u0590-\u05FF\s]+$/, // Regular expression for Hebrew characters
                    message: "נא להזין משפחה בעברית בלבד",
                  },
                })}
              />
              {errors.lastName && (
                <FormErrorMessage color="primary.error">
                  {errors.lastName.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.firstName} flex="1">
              <FormLabel>שם פרטי
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.firstName, errors.firstName, firstNameValue)}
                autoComplete="off"
                {...register("firstName", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[\u0590-\u05FF\s]+$/, // Regular expression for Hebrew characters
                    message: "נא להזין שם בעברית בלבד",
                  },
                })}
              />
              {errors.firstName && (
                <FormErrorMessage color="primary.error">
                  {errors.firstName.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.idNumber} flex="1">
              <FormLabel>ת.ז.
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="ת.ז. תיקנית כולל ספרת ביקורת"
                aria-label="ת.ז. תיקנית כולל ספרת ביקורת"
                style={getFieldStyles(touchedFields.idNumber, errors.idNumber, idNumberValue)}
                autoComplete="off"
                {...register("idNumber", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^\d{9}$/, // Regular expression for exactly 9 digits
                    message: "ת.ז. לא תקינה",
                  },
                })}
              />
              {errors.idNumber && (
                <FormErrorMessage color="primary.error">
                  {errors.idNumber.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </Stack>
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
            <FormControl isInvalid={!!errors.phoneNumber} flex="1">
              <FormLabel>טלפון נייד
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="דוגמא 055-5555555"
                style={getFieldStyles(touchedFields.phoneNumber, errors.phoneNumber, phoneNumberValue)}
                autoComplete="off"
                maxLength={11}
                {...register("phoneNumber", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^(0[23489]\d{7}|0[23489]-?\d{7}|05[0-9]\d{7}|05[0-9]-?\d{7})$/,
                    message: "מספר טלפון לא תקני",
                  },
                })}
              />
              {errors.phoneNumber && (
                <FormErrorMessage color="primary.error">
                  {errors.phoneNumber.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl isInvalid={!!errors.email} flex="1">
              <FormLabel>דואר אלקטרוני
                <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="דוגמא: mail@example.com"
                style={getFieldStyles(touchedFields.email, errors.email, emailValue)}
                autoComplete="off"
                {...register("email", {
                  required: "ערך חובה",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "דואר אלקטרוני לא תקני",
                  },
                })}
              />
              {errors.email && (
                <FormErrorMessage color="primary.error">
                  {errors.email.message}
                </FormErrorMessage>
              )}
            </FormControl>
          </Stack>
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
                          <FormControl isInvalid={!!errors.startEmpDate} flex="1">
                            <FormLabel>תאריך תחילת עבודה
                              <Icon as={FaAsterisk} color="red" fontSize={"9.8px"} ml="2" />
                            </FormLabel>
                           
                            <Controller
                              name="startEmpDate"
                              control={control}
                              defaultValue={""}
                              rules={{
                                required: "ערך חובה"
                              }}
                              render={({ field, ref }) => (
                                <DatePicker
                                  calendarClassName="brand-cal"
                                  {...field}
                                  ref={ref}
                                  selected={field.value}
                                  onChange={(date) => field.onChange(date)}
                                  dateFormat="dd/MM/yyyy"
                                  placeholderText="dd/MM/yyyy"
                                  locale={he}
                                  showMonthDropdown
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={75}
                                  minDate={new Date(1934, 0, 1)}
                                  autoComplete="off"
                                  customInput={
                                    <input
                                      maxLength={10}
                                      aria-label="תאריך תחילת עבודה הכנס בפורמט dd/mm/yyyy"
                                      style={getFieldStyles(touchedFields.startEmpDate, errors.startEmpDate, startEmpDateValue)}
                                    />
                                  }
                                />
                              )}
                            />
                            {errors.startEmpDate && (
                              <FormErrorMessage color="primary.error">
                                {errors.startEmpDate.message}
                              </FormErrorMessage>
                            )}
                          </FormControl>
                          <FormControl isInvalid={!!errors.insuredSalary} flex="1">
              <FormLabel>שכר מבוטח 
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder=""
                style={getFieldStyles(touchedFields.insuredSalary, errors.insuredSalary, insuredSalaryValue)}
                autoComplete="off"
                {...register("insuredSalary", {
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "יש להזין ספרות בלבד",
                  },
                })}
              />
              {errors.insuredSalary && (
                <FormErrorMessage color="primary.error">
                  {errors.insuredSalary.message}
                </FormErrorMessage>
              )}
            </FormControl>
            <FormControl  flex="1">
              <FormLabel>תפקיד\עיסוק 
              </FormLabel>
              <Input
                type="text"
                defaultValue={""}
                placeholder="שדה חובה (עברית)"
                style={getFieldStyles(touchedFields.jobDescription, errors.jobDescription, jobDescriptionValue)}
                autoComplete="off"
                {...register("jobDescription", {
                })}
              />
             
            </FormControl>
           

           
          </Stack>
          <Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">

<FormControl  flex="1">
        
        <Checkbox
          size='sm'
          flex="1"
          defaultChecked
          {...register("section14")}
        >
חתום על סע' 14              </Checkbox>
                  
      </FormControl>
    
      
<FormControl  flex="1">
        
        <Checkbox
          size='sm'
          flex="1"
          defaultChecked
          {...register("continuingEducationFund")}
        >
האם קיימת קרן השתלמות             </Checkbox>
                  
      </FormControl>
     


</Stack>

<Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
<FormControl  flex="1">
        <FormLabel>תקציב פיצויים  
        </FormLabel>
        <Input
          type="text"
          defaultValue={""}
          style={getFieldStyles(touchedFields.compensationBudget, errors.compensationBudget, compensationBudgetValue)}
          autoComplete="off"
          {...register("compensationBudget", {
           
          })}
        />
       
       
      </FormControl>
      <FormControl  flex="1">
        <FormLabel>קרן השתלמות משכר   
        </FormLabel>
        <Input
          type="text"
          defaultValue={""}
           style={getFieldStyles(touchedFields.continuingEducationFundSalary, errors.continuingEducationFundSalary, continuingEducationFundSalaryValue)}
          autoComplete="off"
          {...register("continuingEducationFundSalary", {
           
          })}
        />
       
       
      </FormControl>
</Stack>

<Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
<FormControl  flex="1">
        <FormLabel>תקציב תגמולי עובד   
        </FormLabel>
        <Input
          type="text"
          defaultValue={""}
          style={getFieldStyles(touchedFields.employeeCompensationBudget, errors.employeeCompensationBudget, employeeCompensationBudgetValue)}
          autoComplete="off"
          {...register("employeeCompensationBudget", {
            pattern: {
              value: /^\d+(\.\d+)?$/,
              message: "יש להזין ספרות בלבד",
            },
          })}
        />
       
       
      </FormControl>
      <FormControl  flex="1">
        <FormLabel>תקציב תגמולי מעסיק
        </FormLabel>
        <Input
          type="text"
          defaultValue={""}
          style={getFieldStyles(touchedFields.employerBenefitsBudget, errors.employerBenefitsBudget, employerBenefitsBudgetValue)}
          autoComplete="off"
          {...register("employerBenefitsBudget", {
            pattern: {
              value: /^\d+(\.\d+)?$/,
              message: "יש להזין ספרות בלבד",
            },
          })}
        />
       
       
      </FormControl>
</Stack>

<Stack spacing="30px" direction={{ base: "column", md: "row" }} wrap="wrap">
<FormControl  flex="1">
        <FormLabel>תתקציב א.כ.ע
        </FormLabel>
        <Input
          type="text"
          defaultValue={""}
          style={getFieldStyles(touchedFields.budgetOfAka, errors.budgetOfAka, budgetOfAkaValue)}
          autoComplete="off"
          {...register("budgetOfAka", {
            pattern: {
              value: /^\d+(\.\d+)?$/,
              message: "יש להזין ספרות בלבד",
            },
          })}
        />
       
       
      </FormControl>
      <FormControl  flex="1">
        <FormLabel> הפרשות קה"ש עובד ומעסיק
        </FormLabel>
        <Input
          type="text"
          defaultValue={""}
          style={getFieldStyles(touchedFields.employeeAndEmployerSocialSecurityContributions, errors.employeeAndEmployerSocialSecurityContributions,employeeAndEmployerSocialSecurityContributionsValue)}
          autoComplete="off"
          {...register("employeeAndEmployerSocialSecurityContributions", {
            pattern: {
              value: /^\d+(\.\d+)?$/,
              message: "יש להזין ספרות בלבד",
            },
          })}
        />
       
       
      </FormControl>
</Stack>

        </GreyBox>
      </Stack>
     

    

   

   

   

      <VStack p="30px 15px">
        <Button
          type="submit"
          variant="greenButton"
        >
          שלח
        </Button>
      </VStack>

      <AlertErrors isOpen={isOpen} onClose={onClose} invalidFields={invalidFields} />

      {isloading && <FullScreenLoader isOpen={true} />}

    </Box>
  )
}